// src/hooks/rq/usePetQuery.js
import { useQueryClient } from '@tanstack/react-query';
export function usePetQuery(petId) {
  const qc = useQueryClient();
  return qc.getQueryData(['pet', petId]);
}
